import React from "react";
import { DataTable } from "../../../../common";
import {
  ThemedButton,
  PaginationNew,
  IconMenuOption,
} from "../../../../controls";
import { FaSort } from "react-icons/fa6";
import "./ListStyles.scss";
import moment from "moment";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  AiFillFilter,
  AiOutlineDelete,
  AiOutlineEdit,
  AiOutlineRedo,
} from "react-icons/ai";

const TechnicianList = (props) => {
  var unLockFlag = true;

  const data = props.TechniciansList;

  const renderHeader = (label, islastColumn = false, sortable = false) => {
    return (
      <div className="custom-column-header">
        <text>{label}</text>

        <div className="sortIcon">
          {sortable ? (
            <FaSort
              style={{ color: "rgba(0,0,0,0.25)", cursor: "pointer" }}
              size={12}
              onClick={
                props.onTechnicianListSortClick !== null
                  ? () => props.onTechnicianListSortClick(label)
                  : () => {}
              }
            />
          ) : null}
          {islastColumn ? (
            <div className="partition none" />
          ) : (
            <div className="partition" />
          )}
        </div>
      </div>
    );
  };

  const renderStatusHeader = (label) => {
    const Active = {
      width: "5px",
      height: "5px",
      borderRadius: "50%",
      backgroundColor: "#52C41A",
    };
    const Inactive = {
      width: "5px",
      height: "5px",
      borderRadius: "50%",
      backgroundColor: "#D9D9D9",
    };

    const Options = [
      { label: "Active", icon: <div style={Active} /> },
      { label: "Inactive", icon: <div style={Inactive} /> },
    ];
    return (
      <div className="custom-column-header">
        <text>{label}</text>
        <div className="sortIcon">
          {
            <IconMenuOption
              options={Options}
              columnName={label}
              showSelectedItem={true}
              menuIcon={<AiFillFilter size={12} color="rgba(0,0,0,0.25)" />}
              onClickFilter={props.onTechnicianListFilterClick}
            />
          }
          <div className="partition" />
        </div>
      </div>
    );
  };

  const renderTechnicianStatus = (status) => {
    const Active = { backgroundColor: "#52C41A" };
    const Inactive = { backgroundColor: "#D9D9D9" };
    const Locked = { backgroundColor: "#FF4D4F" };

    let statusStyle;
    if (status === "Active") {
      statusStyle = Active;
    }
    if (status === "Inactive") {
      statusStyle = Inactive;
    }
    if (status === "Locked") {
      statusStyle = Locked;
    }

    return (
      <div className="status-wrapper">
        <div className="status-circle me-2" style={statusStyle}></div>
        <text>{status}</text>
      </div>
    );
  };

  const renderActionHeader = (label, islastColumn = true, center = false) => {
    return (
      <div className={`custom-column-header ${center ? "header-text" : ""}`}>
        <text>{label}</text>
        <div className="sortIcon">
          {/*  No sort icon  */}
          <div className={`partition ${islastColumn === true ? "none" : ""}`} />
        </div>
      </div>
    );
  };

  const renderEditDeleteResetPasswordAction = (row) => {
    const Options = [
      { label: "Edit", icon: <AiOutlineEdit size={18} /> },
      { label: "Delete", icon: <AiOutlineDelete size={18} /> },
      { label: "Reset Password", icon: <AiOutlineRedo size={18} /> },
    ];
    return (
      <IconMenuOption
        row={row}
        options={Options}
        menuIcon={<BsThreeDotsVertical size={22} />}
        onclickEdit={props.onEditTechnicianClick}
        onclickDelete={props.onDeleteTechnicianClick}
        onclickResetPassword={props.onResetPasswordTechnicianClick}
      />
    );
  };

  const renderUnlockButton = (row) => {
    return (
      <div>
        <ThemedButton
          title="Unlock"
          styles="link "
          onClick={
            props.onUnlockTechnicianAccountClick !== null
              ? () => props.onUnlockTechnicianAccountClick(row)
              : () => {}
          }
        />
      </div>
    );
  };

  const renderAddressDetails = (row) => {
    const location = row?.centerInfo?.addressInfo?.locationName
      ? row.centerInfo.addressInfo.locationName
      : "";

    const district = row?.centerInfo?.addressInfo?.districtInfo?.name
      ? ", " + row.centerInfo.addressInfo.districtInfo.name
      : "";

    const state = row?.centerInfo?.addressInfo?.stateInfo?.name
      ? ", " + row.centerInfo.addressInfo.stateInfo.name
      : "";

    return `${location}${district}${state}`;
  };

  // Columns info with row value to use (row : single object in data array)
  const columns = [
    {
      name: renderHeader("Technician Name", false, true),
      id: "technician_Name",
      center: false,
      sortable: false,
      selector: (row) =>
        row !== null && row !== undefined
          ? `${
              (row?.firstName !== null && row?.firstName !== undefined
                ? `${row?.firstName
                    .charAt(0)
                    .toUpperCase()}${row?.firstName.slice(1)}`
                : "") +
              " " +
              (row?.lastName !== null && row?.lastName !== undefined
                ? `${row?.lastName
                    .charAt(0)
                    .toUpperCase()}${row?.lastName.slice(1)}`
                : "")
            }`
          : "-",
    },
    {
      name: renderStatusHeader("Status"),
      id: "status",
      center: false,
      sortable: false,
      selector: (row) =>
        row?.user?.isLocked
          ? renderTechnicianStatus("Locked")
          : row.checkIn === true
          ? renderTechnicianStatus("Active")
          : renderTechnicianStatus("Inactive"),
    },
    {
      name: renderHeader("Added On", false, true),
      id: "added_on",
      center: false,
      sortable: false,
      selector: (row) =>
        row?.createdAt
          ? moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss")
          : "-",
    },
    {
      name: renderHeader("Assigned Device", false, true),
      id: "assign_device",
      center: false,
      sortable: false,
      selector: (row) =>
        row?.deviceInfo ? row?.deviceInfo?.mst_device?.serialNo ?? "" : "-",
    },
    {
      name: renderHeader("Device Type", false, true),
      id: "device_type",
      center: false,
      sortable: false,
      selector: (row) =>
        row?.deviceInfo
          ? row?.deviceInfo?.mst_device?.deviceType?.type ?? ""
          : "-",
    },
    // {
    //   name: renderHeader("Device Location"),
    //   id: "device_location",
    //   center: false,
    //   sortable: true,
    //   selector: (row) => renderAddressDetails(row),
    // },
    {
      name: renderActionHeader("Action", true, true),
      id: "action",
      center: true,
      sortable: false,
      selector: (row) =>
        row?.user?.isLocked
          ? renderUnlockButton(row)
          : renderEditDeleteResetPasswordAction(row),
    },
  ];

  //-------------------- Render Column Elements --------------------

  const BootyCheckbox = React.forwardRef(({ onClick, ...rest }, ref) => (
    <div className="form-check">
      <input
        htmlFor="booty-check"
        type="checkbox"
        className="form-check-input"
        ref={ref}
        onClick={onClick}
        {...rest}
      />
      <label className="form-check-label" id="booty-check" />
    </div>
  ));

  return (
    <div className="technician-list-info-wrapper">
      <div className="table-list-wrapper">
        <DataTable
          columns={columns}
          data={data}
          onSelectedRowsChange={(state) =>
            props.onSelectedRowsChange(state.selectedRows)
          }
          clearSelectedRows={props.clearSelectedRows}
          selectableRows
          selectableRowsComponent={BootyCheckbox}
          selectableRowsHighlight={true}
          pagination
          // paginationComponent={PaginationNew}
          paginationRowsPerPageOptions={[10, 20]}
          paginationPerPage={props.limit}
          paginationDefaultPage={props.page}
          paginationServer
          paginationTotalRows={props.totalTechnicians}
          onChangeRowsPerPage={props.onChangeRowsPerPage}
          onChangePage={props.onChangePage}
        />
      </div>
    </div>
  );
};

export default TechnicianList;
